import type { ClientProps } from '@pages/Invoicing/context/types'
import type { AddEditServiceModalFormProps } from '../components/AddEditServiceModal/form/types'
import type { FiliDataProps } from '@hooks/useUser/types'

export interface MapSubmitFormValuesProps {
  clientData: ClientProps | null
  filiData: FiliDataProps | null
  formData: AddEditServiceModalFormProps
}

export const mapSubmitFormValues = ({ clientData, filiData, formData }: MapSubmitFormValuesProps) => {
  formData.filiCode = filiData?.filiCode || ''
  formData.cdClientCode = clientData?.cdClienteNl || ''
  formData.startBillingDate = clientData?.fatDataInicio || ''
  formData.descClientName = clientData?.desClienteNl || ''
  formData.startPeriod = clientData?.fatPeriodoInicio || ''
  formData.endPeriod = clientData?.fatPeriodoFim || ''
  formData.billingDay = clientData?.fatPeriodoDia || ''
  formData.fatCompetenceDate = filiData?.startPeriod || ''
  formData.clientType = clientData?.tipoCliente || ''

  return formData
}
